

const urls = {
    SCHEDULED_OPERATION_EQUIPMENT_LAYOUT: 'operative-plan/scheduled-operation-equipment-layout',
    SCHEDULED_OPERATION_EQUIPMENT_LAYOUT_ITEM: 'operative-plan/scheduled-operation-equipment-layout-item',
    SCHEDULED_OPERATION_EQUIPMENT: 'operative-plan/scheduled-equipment-operation',
    COPY_SCHEDULED_OPERATION_EQUIPMENT: 'operative-plan/copy-scheduled-equipment-operation',
    SCHEDULED_SHEET_PRINT: 'operative-plan/scheduled-operation-scheduled-print',
    ETA_SHEET_PRINT: 'operative-plan/scheduled-operation-eta-print',
    DAILY_PLANNING_SHEET_PRINT: 'operative-plan/scheduled-operation-daily-planning-print',
    DAILY_PLANNING_REPORT_DATA: 'operative-plan/scheduled-operation-daily-planning-report-data',
    SEND_PLAN: 'operative-plan/daily-plan',
    RECURRING_OPERATION_TEMPLATE: 'operative-plan/recurring-operation-template',
    MASS: 'operative-plan/scheduled-equipment-operation-mass?dailyPlanDate=',
    VALIDATION: 'operative-plan/daily-plan-validation',
    VALIDATION_ALL: 'operative-plan/daily-plan-validation-list',
    DAILY_PLAN_PUBLISH: 'operative-plan/daily-plan-validation?dailyPlanId=',
    DAILY_PLAN_SCHEDULED_OPERATION: 'operative-plan/daily-plan-last-published-op',

    FISCAL_NOTIFICATION_AGGREGATION: 'fiscal-notification-aggregation',
    FISCAL_NOTIFICATION_AGGREGATION_AGGREGABLE: 'fiscal-notification-aggregation-aggregable',

    FIXED_BALANCE_SPLIT_GET_LOTS: 'operative-plan/daily-plan-last-published-op/list-of-movement-instruction-with-common-data',

    EQUIPMENT_TRACKING: 'equipment-tracking',
    SCHEDULED_OPERATION_BY_LOT_ID: 'operative-plan/scheduled-operation-by-lot-id',
    SCHEDULED_DOCUMENTATION_MAIL: 'operative-plan/scheduling-documentation-mail',
    CLOSE_VOYAGE_DOCUMENTATION_COMPLETE: 'operative-plan/close-voyage-documentation-complete',
    REOPEN_VOYAGE_DOCUMENTATION_COMPLETE: 'operative-plan/reopen-voyage-documentation-complete',

}

import genericService from '../genericService';

export default {
    async getScheduledOperationEquipmentLayout(id, callback){
        await genericService.getItem(urls.SCHEDULED_OPERATION_EQUIPMENT_LAYOUT, id).then(callback);
    },
    async deleteScheduledOperationEquipmentLayouItem(id, body, callback){
        await genericService.deleteBody(urls.SCHEDULED_OPERATION_EQUIPMENT_LAYOUT_ITEM, id, body).then(callback);
    },
    async addScheduledOperationEquipmentLayouItem(body, callback){
        await genericService.post(urls.SCHEDULED_OPERATION_EQUIPMENT_LAYOUT_ITEM, body).then(callback);
    },
    async saveScheduledOperationEquipmentLayouItem(body, callback){
        await genericService.put(urls.SCHEDULED_OPERATION_EQUIPMENT_LAYOUT_ITEM, body).then(callback);
    },
    async getScheduledEquipmentOperations(body, callback){
        await genericService.get(urls.SCHEDULED_OPERATION_EQUIPMENT, body).then(callback);
    },
    async saveScheduledEquipmentOperation(body, callback){
        await genericService.put(urls.SCHEDULED_OPERATION_EQUIPMENT, body).then(callback);
    },
    async createScheduledEquipmentOperation(body, callback){
        await genericService.post(urls.SCHEDULED_OPERATION_EQUIPMENT, body).then(callback);
    },
    async copyScheduledEquipmentOperation(id, body, callback){
        await genericService.putNoId(urls.COPY_SCHEDULED_OPERATION_EQUIPMENT + '/' + id, body).then(callback);
    },
    async deleteScheduledEquipmentOperations(id, callback){
        await genericService.delete(urls.SCHEDULED_OPERATION_EQUIPMENT, id).then(callback);
    },
    async printScheduledSheet(body, callback){
        await genericService.dowloadFile(urls.SCHEDULED_SHEET_PRINT, body).then(callback);
    },
    async printEtaSheet(body, callback){
        await genericService.dowloadFile(urls.ETA_SHEET_PRINT, body).then(callback);
    },
    async printDailyPlanningSheet(body, callback){
        await genericService.dowloadFile(urls.DAILY_PLANNING_SHEET_PRINT, body).then(callback);
    },
    async getDailyPlanReportData(body, callback){
        await genericService.get(urls.DAILY_PLANNING_REPORT_DATA, body).then(callback);
    },
    async sendPlan(body, callback){
        await genericService.post(urls.SEND_PLAN, body).then(callback);
    },
    async getRecurringOperationTemplate(body, callback){
        await genericService.get(urls.RECURRING_OPERATION_TEMPLATE, body).then(callback);
    },
    async addMass(body,date, callback){
        await genericService.post(urls.MASS + date, body).then(callback);
    },
    async dailyPlanValidate(body, callback){
        await genericService.put(urls.VALIDATION, body,).then(callback);
    },
    async dailyPlanValidateAll(body, callback){
        await genericService.post(urls.VALIDATION_ALL, body,).then(callback);
    },
    
    async dailyPlanPublish(body, planId, callback){
        await genericService.post(urls.DAILY_PLAN_PUBLISH + planId, body).then(callback);
    },

    async getDailyPlanScheduledOperationById(id, callback){
        await genericService.getItem(urls.DAILY_PLAN_SCHEDULED_OPERATION, id).then(callback);
    },
    async getFiscalNotificationAggregation(id, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_AGGREGATION + '/' + id, {}).then(callback);
    },
    async addFiscalNotificationAggregation(body, callback){
        await genericService.post(urls.FISCAL_NOTIFICATION_AGGREGATION, body).then(callback);
    },
    async removeFiscalNotificationAggregation(id, callback){
        await genericService.delete(urls.FISCAL_NOTIFICATION_AGGREGATION, id).then(callback);
    },
    async getFiscalNotificationAggregationAggregable(id, callback){
        await genericService.get(urls.FISCAL_NOTIFICATION_AGGREGATION_AGGREGABLE + '/' + id, {}).then(callback);
    },
    async getFixedBalanceSplitLots(id, callback){
        await genericService.get(urls.FIXED_BALANCE_SPLIT_GET_LOTS + '/' + id, {}).then(callback);
    },
    async getEquipmentTracking(params, callback){
        await genericService.get(urls.EQUIPMENT_TRACKING, params).then(callback);
    },
    async saveEquipmentTracking(body, callback){
        await genericService.put(urls.EQUIPMENT_TRACKING, body).then(callback);
    },
    async getScheduledOperationByLotId(id, callback){
        await genericService.getItem(urls.SCHEDULED_OPERATION_BY_LOT_ID, id).then(callback);
    },
    async sendMailScheduledDocumentation(voyageNumber, callback){
        await genericService.get(urls.SCHEDULED_DOCUMENTATION_MAIL + '?voyageNumber=' + voyageNumber, {}).then(callback);
    },
    async reopenVoyageDocumentationComplete(body, callback){
        await genericService.putOnlyId(urls.REOPEN_VOYAGE_DOCUMENTATION_COMPLETE ,body).then(callback);
    },
    async closeVoyageDocumentationComplete(body, callback){
        await genericService.putOnlyId(urls.CLOSE_VOYAGE_DOCUMENTATION_COMPLETE, body ).then(callback);
    },
}